import { IHooksUseRequestAddAdminUserParams } from '@/interfaces';
import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

type TParams = {
	onSuccess?: () => void;
};

type TDataVariables = IHooksUseRequestAddAdminUserParams;
type TResponseData = void;

export const useRequestAddAdminUser = (params?: TParams) => {
	const { isPending, error, mutateAsync } = useMutation({
		mutationKey: [routes.api.users.base, 'add-admin'],
		mutationFn: (data: TDataVariables) => apiClient.post<TResponseData>(routes.api.addAdminUser, data).then(handleApiResponse),
		onSuccess: () => params?.onSuccess?.()
	});

	const triggerAddAdminUser = (data: TDataVariables) => mutateAsync(data);

	return {
		isLoadingAddAdminUser: isPending,
		triggerAddAdminUser,
		error
	};
};
